import React from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';

const TABLE_COLUMNS = [
  { key: 'jobId', name: 'Job Id', resizable: true, sortable: true },
  { key: 'batchNumber', name: 'Batch', resizable: true, sortable: true },
  { key: 'status', name: 'Status', resizable: true, sortable: true },
  { key: 'statusDetail', name: 'Detail', resizable: true, sortable: true },
  { key: 'createdOn', name: 'Created On', resizable: true, sortable: true },
  { key: 'updatedOn', name: 'Updated On', resizable: true, sortable: true },
];

export default class BatchesPage extends React.Component {
  static propTypes = {
    batches: PropTypes.object.isRequired,
  };

  state = {
    rows: [],
    originalRows: [],
    columns: TABLE_COLUMNS,
    filters: {},
  };

  componentWillMount = () => {
    const { batches } = this.props;

    const columnArray = TABLE_COLUMNS.map(c => {
      const copy = Object.assign({}, c);
      copy.filterable = true;
      copy.locked = true;
      return copy;
    });

    this.setState({ columns: columnArray });
    this.renderRows(batches);
  };

  componentWillReceiveProps = nextProps => {
    const { batches } = nextProps;
    if (batches.size > 0) {
      this.renderRows(batches);
    }
  };

  onClearFilters = () => {
    // all filters removed
    this.setState({ filters: {} });
  };

  getSize = () => this.getRows().length;

  getRows = () => Data.Selectors.getRows(this.state);

  rowGetter = rowIdx => this.getRows()[rowIdx];

  handleGridSort = (sortColumn, sortDirection) => {
    const { originalRows, rows } = this.state;

    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
      return null;
    };
    const newRows = sortDirection === 'NONE' ? originalRows.slice() : rows.sort(comparer);
    this.setState({ rows: newRows });
  };

  handleRowUpdated = e => {
    const { rows } = this.state;
    Object.assign(rows[e.rowIdx], e.updated);
    this.setState({ ...rows });
  };

  handleFilterChange = filter => {
    const { filters } = this.state;
    const newFilters = Object.assign({}, filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  };

  handleRowClick = (rowIdx, row) => {
    const { rows } = this.state;
    rows[rowIdx] = Object.assign({}, row, { isSelected: !row.isSelected });
    this.setState({ rows });
  };

  renderRows = batches => {
    const _rows = [];
    batches.map(batch => {
      _rows.push({
        jobId: batch.jobId,
        batchNumber: batch.batchNumber,
        source: batch.source,
        status: batch.status,
        statusDetail: batch.statusDetail,
        createdOn: `${new Date(batch.createdOn).toISOString()}`,
        updatedOn: `${new Date(batch.updatedOn).toISOString()}`,
        isSelected: false,
      });
      return _rows;
    });
    return this.setState({ rows: _rows, originalRows: _rows.slice() });
  };

  renderMulti = (multi, itemName, subItemName) => {
    const objectArray = multi.map(object => object[itemName][subItemName]);

    return objectArray.join('\n');
  };

  renderTable = () => {
    const { batches } = this.props;
    const { columns } = this.state;
    return (
      <div style={{ width: '100%' }}>
        {batches.size === 0 || batches === undefined ? (
          <p>No batches</p>
        ) : (
          <ReactDataGrid
            onGridSort={this.handleGridSort}
            rowKey="key"
            id="key"
            columns={columns}
            rowGetter={this.rowGetter}
            rowsCount={this.getSize()}
            onRowUpdated={this.handleRowUpdated}
            rowSelection={{
              showCheckbox: false,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            }}
            onRowClick={this.handleRowClick}
            toolbar={<Toolbar enableFilter />}
            onAddFilter={this.handleFilterChange}
            onClearFilters={this.onClearFilters}
            minHeight={500}
            filterRowsButtonText="Search By Field"
          />
        )}
      </div>
    );
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-8">
            <h1>Batches</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">{this.renderTable()}</div>
        </div>
      </div>
    );
  }
}
